<template>
  <div class="pa-4">
    <v-select
      label="Status"
      v-model="filters.status"
      :items="statusOptions"
      class="background-dark mb-4"
    />

    <form-field
      class="mb-4"
      :schema="userFieldSchema"
      v-model="filters.owners"
    />

    <form-field
      class="mb-4"
      :schema="createdAfterSchema"
      v-model="filters.createdAfter"
    />

    <form-field
      class="mb-4"
      :schema="createdBeforeSchema"
      v-model="filters.createdBefore"
    />

    <v-checkbox
      label="Recently Edited"
      v-model="filters.recentlyEdited"
      class="mb-4"
    />

    <v-checkbox label="Hide Ended" v-model="filters.hideEnded" />
  </div>
</template>

<script>
import FormField from '@/components/formFields/FormField.vue';
import { mapState, mapMutations } from 'vuex';
import { ROLES } from '@/access/roles';

import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'CampaignFilters',
  components: { FormField },
  data() {
    return {
      filters: {
        recentlyEdited: false,
        hideEnded: true,
        status: '',
        owners: [],
        createdAfter: null,
        createdBefore: null,
      },
      statusOptions: [
        { text: 'All', value: '' },
        { text: 'Scheduled', value: 'scheduled' },
        { text: 'Live', value: 'live' },
        { text: 'Ended', value: 'ended' },
      ],

      userFieldSchema: {
        type: 'UserList',
        label: 'Campaign owner',
        placeholder: 'Users',
        role: ROLES.ADMIN,
        dark: true,
      },

      dateFieldSchema: {
        type: 'Date',
        placeholder: 'Select date',
        dark: true,
      },
    };
  },
  computed: {
    ...mapState('campaigns', ['campaignsFilter']),
    createdAfterSchema() {
      return {
        ...this.dateFieldSchema,
        label: 'Created after',
        hide_header: true,
      };
    },
    createdBeforeSchema() {
      return {
        ...this.dateFieldSchema,
        label: 'Created before',
        hide_header: true,
      };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.campaignsFilter)) {
          this.setCampaignsFilter(cloneDeep(this.filters));
        }
      },
    },
  },
  methods: {
    ...mapMutations('campaigns', ['setCampaignsFilter']),
    setFilters() {
      Object.assign(this.filters, cloneDeep(this.campaignsFilter));
    },
  },
  mounted() {
    this.setFilters();
  },
};
</script>
